import React from 'react';
import { EventsQuery } from 'src/graphql/_generated';
import { useStateSelector } from 'src/redux';
import styled from 'styled-components';
import { downloadCsv } from '../util';

const Div = styled.div`
  height: 52px;
  width: 52px;
  border: 1px solid ${({ theme }) => theme.colors.stroke};
  background-color: ${({ theme }) => theme.colors.cultured};
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  * {
    user-select: none;
  }

  &:hover {
    filter: brightness(1.015);
  }
`;

interface ExportCSVProps {
  events: EventsQuery['events'];
  name: string;
}

export const ExportCSV: React.FC<ExportCSVProps> = ({ events, name }) => {
  const colors = useStateSelector(({ theme }) => theme.colors);

  return (
    <Div onClick={() => downloadCsv({ data: events, name })} data-cy="export-actions-csv">
      <svg xmlns="http://www.w3.org/2000/svg" width="19" height="16" viewBox="0 0 19 16" fill="none">
        <path
          d="M17.8477 8.41455C18.1188 8.41459 18.3785 8.52261 18.5703 8.71436C18.7621 8.90611 18.8701 9.16584 18.8701 9.43701V13.5278C18.8701 14.0701 18.6549 14.5906 18.2715 14.9741C17.888 15.3576 17.3675 15.5736 16.8252 15.5737H2.50684C1.96435 15.5737 1.44415 15.3577 1.06055 14.9741C0.676947 14.5905 0.460938 14.0703 0.460938 13.5278V9.43701C0.46099 9.16587 0.569035 8.9061 0.760742 8.71436C0.952461 8.52264 1.21228 8.41464 1.4834 8.41455C1.75464 8.41455 2.01523 8.52256 2.20703 8.71436C2.39865 8.90609 2.50678 9.16594 2.50684 9.43701V13.5278H16.8252V9.43701C16.8252 9.16599 16.9325 8.90608 17.124 8.71436C17.3158 8.52256 17.5764 8.41455 17.8477 8.41455ZM8.94141 0.873535C9.34072 0.474205 9.9883 0.474342 10.3877 0.873535L14.4795 4.96436C14.8786 5.36369 14.8786 6.01127 14.4795 6.41064C14.0802 6.80999 13.4326 6.80989 13.0332 6.41064L10.6875 4.06592V10.8013C10.6875 11.3661 10.2299 11.8237 9.66504 11.8237C9.10018 11.8237 8.64258 11.3661 8.64258 10.8013V4.06592L6.29688 6.41064C5.89746 6.80993 5.24996 6.81 4.85059 6.41064C4.45144 6.01126 4.45138 5.3637 4.85059 4.96436L8.94141 0.873535Z"
          fill="url(#paint0_linear_11738_19366)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_11738_19366"
            x1="9.66553"
            y1="0.57373"
            x2="9.66553"
            y2="15.5734"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={colors.gp1} />
            <stop offset="1" stopColor={colors.gp2} />
          </linearGradient>
        </defs>
      </svg>
    </Div>
  );
};
